import {Component , EventEmitter , Input , OnInit , Output} from '@angular/core';
import {DocumentsService} from '../../../../core/services/documents.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'document-tab',
    templateUrl: './document-tab.html',
    styleUrls: ['./../events.component.scss'],
    standalone: false
})

export class DocumentTabComponent implements OnInit {

  @Input() uploadedFiles;
  @Input() eventData;
  @Input() type;
  @Input() id;
  @Input() readOnly = false;

  @Output() filesCount = new EventEmitter();
  @Output() filesToUpload = new EventEmitter();
  @Output() filesAccess = new EventEmitter();

  public files = [];
  public uploadedFile = [];
  public publicInfo = [];

  constructor (public documentsService: DocumentsService , private spinner: NgxSpinnerService,
               private toastr: ToastrService, public dialog: MatDialog,
               private translate: TranslateService ) {

  }

  ngOnInit () {
    if (this.eventData) {
      this.documentsService.getDocuments(this.eventData.id , 'event').subscribe((res: any) => {
        if (res.length) {
          for (let item of res) {
            item.url = item.name;
            item.type = item.name.substring(item.name.lastIndexOf('.') + 1 , item.name.length);
            item.name = item.name.split('|_|')[ 1 ];
          }
        }
        this.uploadedFiles = res;
        this.filesCount.emit({count: this.files.length + this.uploadedFiles.length});
      });
    }
  }

  getFile(name) {
    return this.documentsService.getFileStream(name);
  }

  handleInputChangeDoc (event: any) {
    event.preventDefault();
    if (event.target.files[0].size > 2097152) {
      let title = this.translate.instant('failure');
      let msg = this.translate.instant('too_big_file');
      this.toastr.error(msg, title);
      return;
    }
    this.publicInfo.push(false);
    this.filesAccess.emit(this.publicInfo);
    this.uploadedFile.push(event.target.files[ 0 ]);
    if (this.uploadedFiles) {
      this.filesCount.emit({count: this.files.length + this.uploadedFiles.length});
    } else {
      this.filesCount.emit({count: this.files.length});
    }
    if (this.type !== 'newEmail') {
      if (this.type !== 'newEvent') {
        this.spinner.show();
        this.documentsService.uploadDocument({
          type: this.type ,
          connectedId: this.id ,
          files: [ {
            file: this.uploadedFile[ 0 ] ,
            name: this.uploadedFile[ 0 ].name ,
            type: this.uploadedFile[ 0 ].name.split('.').pop()
          } ]
        }).subscribe((res: any) => {
          if (res) {
            this.toastr.success('Document added', 'Success!');
            this.files.push({
              id: res[ 0 ].id ,
              file: this.uploadedFile[ 0 ] ,
              name: this.uploadedFile[ 0 ].name ,
              type: this.uploadedFile[ 0 ].name.split('.').pop()
            });
            this.uploadedFile = [];
            this.spinner.hide();
          }
        });
      } else {
        this.files.push({file: this.uploadedFile[0], name: this.uploadedFile[0].name, type: this.uploadedFile[0].name.split('.').pop()});
        this.filesToUpload.emit(this.files);
        this.uploadedFile = [];
      }
    } else {
      this.spinner.show();
      this.documentsService.uploadDocument({
        type: this.type ,
        connectedId: this.id ? this.id : 0 ,
        files: [ {
          file: this.uploadedFile[ 0 ] ,
          name: this.uploadedFile[ 0 ].name ,
          type: this.uploadedFile[ 0 ].name.split('.').pop()
        } ]
      }).subscribe((res: any) => {
        if (res) {
          this.toastr.success('Document added', 'Success!');
          this.files.push({
            id: res[ 0 ].id ,
            url: res[ 0 ].name,
            file: this.uploadedFile[ 0 ] ,
            name: this.uploadedFile[ 0 ].name ,
            type: this.uploadedFile[ 0 ].name.split('.').pop()
          });
          this.filesToUpload.emit(this.files);
          this.uploadedFile = [];
          this.spinner.hide();
        }
      });
    }
  }

  removeFile (e) {
    const index = this.files.indexOf(e);
    if (index > -1) {
      this.files.splice(index , 1);
    }
    if (this.uploadedFiles) {
      this.filesCount.emit({count: this.files.length + this.uploadedFiles.length});
    } else {
      this.filesCount.emit({count: this.files.length});
    }
    if (e.id) {
      this.documentsService.deleteDocument(e.id).subscribe((res) => {
        if (res) {

        }
      });
    }
  }

  removeFileFromUpload (e) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const index = this.uploadedFiles.indexOf(e);
        if (index > -1) {
          this.uploadedFiles.splice(index , 1);
        }
        if (this.uploadedFiles) {
          this.filesCount.emit({count: this.files.length + this.uploadedFiles.length});
        } else {
          this.filesCount.emit({count: this.files.length});
        }
        this.filesToUpload.emit(this.files);
        this.documentsService.deleteDocument(e.id).subscribe((res) => {
        });
      }
    });
  }

  showFiles (event , id) {
    // console.log(event , id);
    this.filesAccess.emit(this.publicInfo);
    // console.log(this.publicInfo);
    if (id) {
      this.changeState(event , id);
    }

  }

  changeState (event , id) {
    this.spinner.show();
    // console.log(event);
    this.documentsService.updateAccess(id , event.checked).subscribe((res) => {
      if (res) {
        this.spinner.hide();
      }
    });
  }
}
